// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DvBE","title":"styles_title__3dg2f"};